import request from '@/utils/request'

// 查询首页菜单列表
export function cooperationList(query) {
  return request({
    url: '/web/menu/cooperationList',
    method: 'get',
    params: query
  })
}